import React, { useEffect, useState } from 'react'

const useSearchFunction = (value, delay = 500) => {

    const [text, setText] = useState("");
    useEffect(() => {
        const values = setTimeout(() => {
            setText(value)
        }, delay)
        return () => clearTimeout(values);
    }, [value, delay])

    return text
}

export default useSearchFunction